import { useAppDispatch } from 'legacy/lut/hooks/useAppDispatch'
import { useCallback } from 'react'
import { useSelector } from 'react-redux'

import { FINANCIAL_COCKPIT_TRANSLATION_KEYS } from '../../../../../../configs/translations'
import { setCockpitFilterPbm } from '../../../../../../model'
import { selectCockpitFilterPbm, selectCockpitPbmUsers } from '../../../../../../model/selectors'
import { CockpitUserSelect } from '../../../../../cockpitUserSelect/CockpitUserSelect'
import { CockpitFilterLabel } from '../../../cockpitFilterLabel/CockpitFilterLabel'

import styles from './CockpitPbmField.module.scss'

const KEYS = FINANCIAL_COCKPIT_TRANSLATION_KEYS.pbm

export const CockpitPbmField = ({ hideLabel = false }: { hideLabel?: boolean }) => {
  const dispatch = useAppDispatch()
  const selectedPbm = useSelector(selectCockpitFilterPbm)
  const pbmUsers = useSelector(selectCockpitPbmUsers)

  const handleChange = useCallback(
    (emails: string[]) => {
      dispatch(setCockpitFilterPbm(emails))
    },
    [dispatch]
  )

  return (
    <div className={styles.root}>
      <CockpitFilterLabel text={KEYS.label} placeholderOnly={hideLabel} />
      <CockpitUserSelect
        value={selectedPbm}
        onChange={handleChange}
        users={pbmUsers}
        placeholderKey={hideLabel ? KEYS.label : KEYS.all}
        sortByName
      />
    </div>
  )
}
